import { createContext } from 'react';
import { Basket, BasketItem } from 'menus/interfaces';

export interface BasketStoreProps {
  basket: Basket;
  addItem: (item: BasketItem) => void;
  removeItem: (item: BasketItem) => void;
  updateItem: (item: BasketItem) => void;
  updateSocketBasket: () => void;
}

export const initialBasketState = {
  itemList: [],
  total: 0,
  totalQuantity: 0,
  length: 0,
  updated: false,
};

export default createContext<BasketStoreProps>({
  basket: initialBasketState,
  addItem: () => {},
  removeItem: () => {},
  updateItem: () => {},
  updateSocketBasket: () => {},
});
